module.exports = __webpack_public_path__ + "static/media/how-to-3.adefdebd.jpg";